export const NoMatchingCredentialsModalStyles = {
    wrapper:
        "relative flex w-full max-w-lg max-h-[85vh] min-h-0 flex-col overflow-hidden px-6 py-8 text-center",
    headerSection: "shrink-0",
    scrollArea: "min-h-0 flex-1 overflow-y-auto overscroll-contain text-left",
    closeButtonContainer: "absolute right-4 top-4 z-10",
    closeButton:
        "flex h-8 w-8 items-center justify-center rounded-full bg-[#F1F5F9] hover:bg-[#F9FAFB]",
    iconContainer:
        "mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-[#FEF2F2] border-4 shadow-lg border-[#ffffff]",
    iconImage: "h-9 w-9",
    title: "text-xl font-bold text-[#0F172A]",
    claimsIntro: "mt-2 font-semibold text-[14px] text-[#666666]",
    claimsCard:
        "text-left",
    claimsList: "border border-[#E5E7EB] rounded-xl bg-white font-semibold",
    claimItem: "flex items-center gap-2 px-4 py-3 text-sm text-[#0F172A] border-b border-[#E5E7EB] last:border-b-0",
    claimBullet: "h-1.5 w-1.5 shrink-0 rounded-full bg-[#DC2626]",
    showMoreButton:
        "mt-2 text-sm font-medium text-[#951F6F] hover:underline flex items-center gap-1",
    sectionLabel:
        "mt-6 mb-2 text-left text-[13px] font-semibold uppercase tracking-[0.08em] text-[#999999]",
    actionCard:
        "rounded-xl border border-[#E5E7EB] bg-white text-left",
    verifierRow: "flex items-start gap-3 px-4 pt-4 pb-2",
    verifierLogoWrapper:
        "flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-[#E2E8F0] bg-[#F8FAFC] p-1",
    verifierLogo: "h-full w-full object-contain",
    verifierName: "text-sm font-semibold text-[#0F172A] break-all",
    contactLink:
        "text-[12px] text-[#951F6F] font-semibold",
    verifierHelp:
        "px-4 pt-3 pb-4 border-t border-[#F1F5F9] pt-3 text-sm leading-5 text-[#64748B]",
    matchingCardsCard:
        "rounded-xl border border-[#E5E7EB] bg-white",
    matchingCardRow:
        "flex items-center border-b border-[#E5E7EB] px-3 py-2 gap-2",
    matchingCardLogoWrapper:
        "flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-full border border-[#E2E8F0] bg-white",
    matchingCardLogo: "h-full w-full object-cover",
    matchingCardName: "text-sm font-medium text-[#0F172A]",
    footerButton: "mt-6 h-12 shrink-0 rounded-full text-sm font-semibold",
};
